import {HighlightBrand} from '@/__generated__/__types__';
import {Image} from '@/_application/core/components/ui/image';
import {productPlaceholder} from '@/lib/placeholders';
import React from 'react';

interface IProps {
    brand: HighlightBrand;
}

export const BrandInfoCard = ({brand}: IProps) => {
    return (
        <div className="flex h-fit w-60 items-center justify-center gap-5 rounded-xl bg-white p-3">
            <div className="flex h-[80px] w-[80px] shrink-0 select-none items-center justify-center overflow-hidden rounded-[170px] border border-solid border-KPZ_Border">
                <Image
                    src={brand?.img ?? productPlaceholder}
                    alt={brand?.label ?? 'Logo'}
                    className="flex items-center justify-center p-2.5"
                    width={70}
                    height={70}
                    quality={70}
                />
            </div>
            <h1 className="text-xl font-bold text-primary">{brand?.label}</h1>
        </div>
    );
};
